export const formatCurrency = (value: number | null | undefined, currencyCode: string) => {
  if (value == null) return "—";
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currencyCode, // e.g. "EUR"
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      currencyDisplay: "symbol",
    }).format(value);
  } catch {
    return `${value} ${currencyCode ?? ""}`.trim();
  }
};

export const formatHoursHHmm = (hours: number | null | undefined): string => {
  if (hours == null || isNaN(hours)) return "—";

  const totalMinutes = Math.round(hours * 60);

  const hh = Math.floor(totalMinutes / 60);
  const mm = totalMinutes % 60;

  return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
};

export const formatDateTime = (iso?: string | null) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(d);
  } catch {
    return iso;
  }
};

export const formatDateRange = (start?: string | null, end?: string | null) => {
  const from = formatDateTime(start);
  const till = end ? formatDateTime(end) : "Present";
  return `${from} → ${till}`;
};

export const parseISO = (iso?: string | null): number | null => {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  return Number.isNaN(t) ? null : t;
};

export const isPriceRangeWithinFilterRange = (priceStart: number, priceEnd: number, filterStart: number, filterEnd: number) =>
  priceEnd >= filterStart && priceStart <= filterEnd;